import parameters from '@atlassian/jira-relay/src/__generated__/modal_EnforceStorageLimitQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';

type EntryPointParams = {
	cloudId: string;
	productKey: string;
	offeringKey: string;
};

export const enforceStorageLimitsModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-enforce-storage-limits-modal-entrypoint" */ './index'),
	),
	getPreloadProps: ({ cloudId, productKey, offeringKey }: EntryPointParams) => ({
		queries: {
			changeOffering: {
				parameters,
				variables: {
					cloudId,
					productKey,
					offeringKey,
					offeringName: 'standard',
					shouldFetchWithOfferingName: fg('twc_jira_touchpoint_fix'),
				},
			},
		},
	}),
});
